import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// import styles from './style.module.scss'
import Timer from '../timer'
import useTimer from '@shared/hooks/useTimer'
import useStatus from '@shared-submodule/sm-hooks/useStatus'

export default function Upcoming({ data }) {
  const { timer } = useTimer(data?.dStartDate)
  const { sStatusStr } = useStatus(data)

  const [disableData, setDisableData] = useState(!!(sStatusStr === 'live' || sStatusStr === 'completed' || sStatusStr === 'cancelled'))
  const handleTime = () => {
    setDisableData(true)
  }

  useEffect(() => {
    setDisableData(!!(sStatusStr === 'live' || sStatusStr === 'completed' || sStatusStr === 'cancelled'))
  }, [data])

  useEffect(() => {
    timer.sec < 0 && handleTime()
  }, [timer])

  return !disableData ? (
    <section className={'mb-0 mb-md-0 common-box h-100'}>
      <Timer timer={timer} />
    </section>
  ) : null
}

Upcoming.propTypes = {
  data: PropTypes.object
}
